import { render, staticRenderFns } from "./ConfigurarCertificadoFormTexto.vue?vue&type=template&id=14c97bdb&scoped=true&"
import script from "./ConfigurarCertificadoFormTexto.vue?vue&type=script&lang=ts&"
export * from "./ConfigurarCertificadoFormTexto.vue?vue&type=script&lang=ts&"
import style0 from "./ConfigurarCertificadoFormTexto.vue?vue&type=style&index=0&id=14c97bdb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14c97bdb",
  null
  
)

export default component.exports